import { render } from "./user-suggestion.vue?vue&type=template&id=8e09ddd0&scoped=true"
import script from "./user-suggestion.vue?vue&type=script&lang=js"
export * from "./user-suggestion.vue?vue&type=script&lang=js"

import "./user-suggestion.vue?vue&type=style&index=0&id=8e09ddd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e09ddd0"]])

export default __exports__